import React, { useEffect, useState } from "react";
import { Breadcrumb, Row, Col, Typography, Tabs, Skeleton, Input } from "antd";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { components } from "react-select";
import CustomSelect from "./custom-filter/";
import { sessionToSentryRequest } from "@sentry/core";

import SortIcon from "../../../../assets/images/sort-icon.svg";
import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
const { Text } = Typography;
const { Search } = Input;

export default function Filters(props) {
  const {
    filters,
    setQueryFilters,
    selectedFilters,
    setSelectedFilters,
    setTableData,
    createTableData,
    setLoading,
    loadingState,
  } = props;

  const dateOptions = [
    { value: "", label: "All Time" },
    { value: "Today", label: "Today" },
    { value: "Yesterday", label: "Yesterday" },
    { value: "This Week", label: "This Week" },
    { value: "Past Week", label: "Past Week" },
    { value: "This Month", label: "This Month" },
    { value: "Past Month", label: "Past Month" },
    { value: "Past 6 Months", label: "Past 6 Months" },
  ];

  const allCount = filters?.status?.length
    ? filters.status.reduce((item, totalCount) => ({
        count: item.count + totalCount.count,
      })).count
    : 0;

  const getCount = (type) => {
    // if (!filters.status || !filters.status?.length) return 0;
    const x = filters?.status?.filter((item) => item.type == type) || [];
    return x.length ? x[0].count : 0;
    // return items.map((item) => {
    //   return { ...item, type: type === type[0]?.count || 0 };
    // });
  };

  const statusOptions = [
    {
      value: "All Catalogues",
      label: `All Catalogues
      (${allCount})`,
    },
    {
      value: "draft",
      label: `Draft (${getCount("draft")})`,
    },
    {
      value: "published",
      label: `Active (${getCount("published")})`,
    },
    {
      value: "inactive",
      label: `Inactive (${getCount("inactive")})`,
    },
  ];

  const setSearch = (value) => {
    if (selectedFilters.search == value) return;
    setSelectedFilters((state) => {
      return {
        ...state,
        search: value,
      };
    });
    setQueryFilters((state) => {
      return { ...state, search: value };
    });
  };
  const setDate = (option) => {
    setSelectedFilters((state) => {
      return {
        ...state,
        date: option,
      };
    });
    setQueryFilters((state) => {
      return { ...state, date: option.value };
    });
  };
  const setSort = (option) => {
    setSelectedFilters((state) => {
      return {
        ...state,
        sort: option,
      };
    });
    setQueryFilters((state) => {
      return { ...state, sort: option.value };
    });
  };

  const setBuyers = () => {
    if (!selectedFilters.buyer.length) {
      setSelectedBuyers("All Buyers", true);
    }
    setQueryFilters((state) => {
      return {
        ...state,
        buyer: selectedFilters.buyer.includes("All Buyers")
          ? ""
          : selectedFilters.buyer.join(","),
      };
    });
  };

  const setCreated = () => {
    setQueryFilters((state) => {
      return {
        ...state,
        createdby: selectedFilters.createdby.includes("All Users")
          ? ""
          : selectedFilters.createdby.join(","),
      };
    });
  };

  // const resetStatus = () => {
  //   setSelectedFilters((state) => {
  //     return {
  //       ...state,
  //       status: [],
  //     };
  //   });
  //   setQueryFilters((state) => {
  //     return { ...state, status: [] };
  //   });
  // };

  const resetBuyer = () => {
    setSelectedFilters((state) => {
      return {
        ...state,
        buyer: ["All Buyers"],
      };
    });
    setQueryFilters((state) => {
      return { ...state, buyer: "" };
    });
  };

  const resetCreated = () => {
    setSelectedFilters((state) => {
      return {
        ...state,
        createdby: ["All Users"],
      };
    });
    setQueryFilters((state) => {
      return { ...state, createdby: "" };
    });
  };

  const setSelectedBuyers = (value, checked) => {
    setSelectedFilters((state) => {
      const index = state.buyer.indexOf("All Buyers");
      if (index > -1) {
        state.buyer.splice(index, 1);
      }
      return {
        ...state,
        buyer: checked
          ? value == "All Buyers"
            ? [value]
            : [...state.buyer, value]
          : value == "All Buyers"
          ? [value]
          : state.buyer.filter((buyer) => buyer !== value),
      };
    });
  };

  const setSelectedCreated = (value, checked) => {
    setSelectedFilters((state) => {
      const index = state.createdby.indexOf("All Users");
      if (index > -1) {
        state.createdby.splice(index, 1);
      }
      return {
        ...state,
        createdby: checked
          ? value == "All Users"
            ? [value]
            : [...state.createdby, value]
          : value == "All Users"
          ? [value]
          : state.createdby.filter((createdby) => createdby !== value),
      };
    });
  };

  const setStatus = (option) => {
    setLoading(true);
    const tableData = JSON.parse(localStorage.getItem("tableData")) || [];
    setSelectedFilters((state) => {
      return {
        ...state,
        status: option,
      };
    });
    const filteredData =
      option.value === "All Catalogues"
        ? tableData
        : tableData.filter((item) => item.status == option.value);
    setLoading(true);
    if (filteredData.length) createTableData(filteredData);
    else setTableData([]);
    setTimeout(loadingState, 300);
    // setQueryFilters((state) => {
    //   return { ...state, status: selectedFilters.status.join(",") };
    // });
  };

  const setSelectedStatus = (value, checked) => {
    setSelectedFilters((state) => {
      return {
        ...state,
        status: checked
          ? [...state.status, value]
          : state.status.filter((status) => status !== value),
      };
    });
  };

  const CaretDownIcon = () => {
    return <img src={SortIcon} />;
  };

  // const FilterIcon = () => {
  //   return <img src={FilterOutlined} />;
  // };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const FilterIcon = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FilterOutlined />
      </components.DropdownIndicator>
    );
  };

  const buyerOptions =
    filters?.buyer?.map((item) => {
      return { value: item, label: item };
    }) || [];
  buyerOptions.unshift({
    value: "All Buyers",
    label: "All Buyers",
  });

  const createdByKeys = filters?.createdby
    ? Object.keys(filters?.createdby)
    : [];

  const createdOptions =
    createdByKeys.map((item) => {
      return {
        value: item,
        label: filters.createdby[item],
      };
    }) || [];
  createdOptions.unshift({
    value: "All Users",
    label: "All Users",
  });
  //create labels for status options as capitalised status with count
  const status = filters?.status?.map((item) => {
    return {
      value: item.type,
      label: `${item.type.charAt(0).toUpperCase() + item.type.slice(1)} (${
        item.count
      })`,
    };
  });
  return (
    <div>
      <Row
        justify="space-around"
        gutter={[16, 16]}
        style={{ padding: "5px 0 0 0 " }}
      >
        <Col span={4} style={{ maxWidth: "300px" }}>
          <Text className="filter-text" type="secondary">
            Search
          </Text>
          <Input
            className="catalogue-search-input"
            suffix={<SearchOutlined style={{ color: "#bbb" }} />}
            size="large"
            placeholder="Catalogue or Buyer name"
            onBlur={(e) => setSearch(e.target.value)}
            defaultValue={selectedFilters.search}
            onSearch={(e) => {
              setSearch(e);
            }}
            onPressEnter={(e) => {
              setSearch(e.target.value);
            }}
            styles={{
              indicatorSeparator: () => ({
                display: "none",
              }),
            }}
          />
        </Col>
        <Col span={5} style={{ width: "200px" }}>
          <Text className="filter-text" type="secondary">
            Buyer
          </Text>
          <CustomSelect
            isMulti
            placeholder="Buyer"
            options={buyerOptions}
            onChange={setSelectedBuyers}
            onButtonClick={setBuyers}
            selected={selectedFilters.buyer}
            onReset={resetBuyer}
          />
        </Col>
        <Col span={5} style={{ width: "170px" }}>
          <Text className="filter-text" type="secondary">
            User
          </Text>
          <CustomSelect
            isMulti
            placeholder="Created By"
            options={createdOptions}
            selected={selectedFilters.createdby}
            onButtonClick={setCreated}
            onReset={resetCreated}
            onChange={setSelectedCreated}
            labelOptions={filters?.createdby}
          />
        </Col>
        <Col span={3} style={{ width: "170px" }}>
          <Text className="filter-text" type="secondary">
            Status
          </Text>
          <Select
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: "#278977",
              },
            })}
            isSearchable={false}
            placeholder="Status"
            style={{ maxWidth: "200px" }}
            options={statusOptions}
            onChange={(option) => setStatus(option)}
            styles={{
              indicatorSeparator: () => ({
                display: "none",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                background:
                  selectedFilters.status.value == "All Catalogues"
                    ? "#fff"
                    : "#f5f5f5",
                height: "36px",
                borderRadius: "0 4px 4px 0",
                border:
                  selectedFilters.status.value == "All Catalogues"
                    ? "none"
                    : "1px solid black",
                "border-left": "none",
              }),
              valueContainer: (base) => ({
                ...base,
                background:
                  selectedFilters.status.value == "All Catalogues"
                    ? "#fff"
                    : "#f5f5f5",
                color: "#777",
                width: "80%",
                borderRadius: "4px 0 0 4px",
                border:
                  selectedFilters.status.value == "All Catalogues"
                    ? "none"
                    : "1px solid black",
                "border-right": "none",
                height: "36px",
                fontWeight:
                  selectedFilters.status.value == "All Catalogues"
                    ? "normal"
                    : "bold",
              }),
              option: (styles, state) => ({
                ...styles,
                cursor: "pointer",
              }),
            }}
            defaultValue={selectedFilters.status}
          />
          {/* <CustomSelect
            placeholder="Status"
            // style={{ width: "100%" }}
            isMulti
            options={status}
            onChange={setSelectedStatus}
            onButtonClick={setStatus}
            selected={selectedFilters.status}
            onReset={resetStatus}
          /> */}
        </Col>
        <Col span={3} style={{ width: "170px" }}>
          <Text className="filter-text" type="secondary">
            Created On
          </Text>
          <Select
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: "#278977",
              },
            })}
            styles={{
              indicatorSeparator: () => ({
                display: "none",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                background:
                  selectedFilters.date.value == "" ? "#fff" : "#f5f5f5",
                height: "36px",
                borderRadius: "0 4px 4px 0",
                border:
                  selectedFilters.date.value == "" ? "none" : "1px solid black",
                "border-left": "none",
              }),
              valueContainer: (base) => ({
                ...base,
                background:
                  selectedFilters.date.value == "" ? "#fff" : "#f5f5f5",
                color: "#777",
                width: "80%",
                borderRadius: "4px 0 0 4px",
                border:
                  selectedFilters.date.value == "" ? "none" : "1px solid black",
                "border-right": "none",
                height: "36px",
                fontWeight:
                  selectedFilters.date.value == "" ? "normal" : "bold",
              }),
              option: (styles, state) => ({
                ...styles,
                cursor: "pointer",
              }),
            }}
            isSearchable={false}
            placeholder="Date Created"
            style={{ maxWidth: "200px" }}
            options={dateOptions}
            onChange={(option) => setDate(option)}
            // components={{ DropdownIndicator: FilterIcon }}
            defaultValue={selectedFilters.date}
          />
        </Col>
        <Col span={3} style={{ width: "120px" }}>
          <Text className="filter-text" type="secondary">
            Sort
          </Text>
          <Select
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: "#278977",
              },
            })}
            styles={{
              indicatorSeparator: () => ({
                display: "none",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                background: "#f5f5f5",
                height: "36px",
                borderRadius: "0 4px 4px 0",
                border: "1px solid black",
                "border-left": "none",
              }),
              valueContainer: (base) => ({
                ...base,
                background: "#f5f5f5",
                color: "#777",
                width: "80%",
                borderRadius: "4px 0 0 4px",
                border: "1px solid black",
                "border-right": "none",
                height: "36px",
                fontWeight: "bold",
              }),
              option: (styles, state) => ({
                ...styles,
                cursor: "pointer",
              }),
              menu: (styles) => ({
                ...styles,
                width: "200px",
                right: 0,
              }),
            }}
            isSearchable={false}
            placeholder="Sort"
            options={[
              { value: "date", label: "Recently Created" },
              { value: "collection", label: "Name of the catalogue" },
            ]}
            defaultValue={selectedFilters.sort}
            onChange={(option) => setSort(option)}
            components={{ DropdownIndicator }}
          />
        </Col>
      </Row>
    </div>
  );
}
